module.exports = __webpack_public_path__ + "static/media/bu-hover.4a8a3323.jpg";